import { RelocationOrderTransportMethod } from "@/api-schema-enums";
import i18next from "i18next";

export function getRelocationOrderTransportMethodLabel(
  transportMethod: RelocationOrderTransportMethod | null | undefined,
): string {
  if (!transportMethod) {
    return i18next.t("fit:NoTransportMethodFound");
  }

  return transportMethod === RelocationOrderTransportMethod.OwnAxle
    ? i18next.t("fit:TransportMethodOwnAxle")
    : i18next.t("fit:TransportMethodTransportCompany");
}
